import React, { Component } from 'react';

import { observer } from 'mobx-react';

import Loader from '../Loader';
import ErrorMessage from './ErrorMessage';
import CardTypeLogos from './CardTypeLogos';
import SecurityMetricsIcon from './SecurityMetricsIcon';
import { MONTHS_AS_OPTIONS } from './constants/months';
import { YEARS_AS_OPTIONS } from './constants/years';
import { detectCardType } from './constants/cardTypes';
import { FIELDS, REQUIRED_ICON_RENDER } from './constants/fieldsCreditCardChange';
import { ERRORS } from './constants/errors';
import membershipStore from '../../stores/membershipStore';
import { processCreditCardChangeForm } from '../../actions/membershipActions';
import { T } from '../../stores/textStore';
import Alert from '../../views/membership/components/Alert';

class CreditCardChangeForm extends Component {
	validate(fieldName) {
		const { creditCardChangeForm, creditCardChangeFormErrors } = membershipStore;
		creditCardChangeFormErrors.delete(fieldName);			
		if (!creditCardChangeForm.get(fieldName) && this.isRequired(fieldName)) {
			creditCardChangeFormErrors.set(fieldName, ERRORS.REQUIRED);
		} else if (creditCardChangeForm.get(fieldName) && FIELDS[fieldName].regex &&
				!FIELDS[fieldName].regex.test(creditCardChangeForm.get(fieldName))) {
			creditCardChangeFormErrors.set(fieldName, `Please enter a valid ${FIELDS[fieldName].label}`);
		} else if (fieldName === 'cc_number' && !creditCardChangeForm.get('payment_method')) {			
			creditCardChangeFormErrors.set(fieldName, ERRORS.INVALID_CCNUMBER);
		}
	}

	validateEntireForm() {
		for (let key in FIELDS) {
			this.validate(key);
		}
	}

	isFormValid() {		
		return !membershipStore.creditCardChangeFormErrors.size;
	}	

	isRequired(fieldName) {		
		return FIELDS[fieldName].required;	
	}

	handleChange = (event) => {
		event.preventDefault();
		const { creditCardChangeForm, creditCardChangeFormErrors } = membershipStore;		
		creditCardChangeForm.set(event.target.name, event.target.value);			
		if (event.target.name === 'cc_number') {			
			this.handlecc_numberChange();
		}	
		if (creditCardChangeFormErrors.get(event.target.name)) {
			this.validate(event.target.name);
		}
	}

	handleBlur = (event) => {
		event.preventDefault();
		this.validate(event.target.name);
	}	

	handlecc_numberChange() {
		const { creditCardChangeForm } = membershipStore;
		const cardType = detectCardType(creditCardChangeForm.get('cc_number'));
		if (!cardType) {
			creditCardChangeForm.set('payment_method', '');
			return;
		}		
		creditCardChangeForm.set('payment_method', cardType.paymentMethod);
	}

	handleSubmit = (event) => {
		event.preventDefault();				
		this.validateEntireForm();
		if (this.isFormValid()) {					
			processCreditCardChangeForm();
		}
	}	

	renderInput(name) {
		const { creditCardChangeForm, creditCardChangeFormErrors, processing } = membershipStore			
		return (
			<span>
				<label>
					{this.isRequired(name) && REQUIRED_ICON_RENDER}							
					{T(FIELDS[name].label)}
				</label>
				<input 				
					type="text" 
					className={'form-control rounded-0' + (creditCardChangeFormErrors.get(name) ? ' is-invalid' : '')}
					name={name} 
					placeholder="" 
					value={creditCardChangeForm.get(name)} 
					onChange={this.handleChange}
					onBlur={this.handleBlur}					
					disabled={processing.get()}
				/>
				<ErrorMessage text={creditCardChangeFormErrors.get(name)} />
			</span>
		);
	}

	renderSelect(name) {
		const { creditCardChangeForm, creditCardChangeFormErrors, processing } = membershipStore;
		let optionsRender = [];
		if (name === 'cc_expiration_month') {
			optionsRender.push(<option key='EMPTY' value=""></option>);
			optionsRender = optionsRender.concat(MONTHS_AS_OPTIONS);
		} else if (name === 'cc_expiration_year') {
			optionsRender.push(<option key='EMPTY' value=""></option>);
			optionsRender = optionsRender.concat(YEARS_AS_OPTIONS);		
		}
		return (
			<span>
				<label>
					{this.isRequired(name) && REQUIRED_ICON_RENDER}							
					{T(FIELDS[name].label)}
				</label>
				<select                   								 
					className="form-control" 
					name={name}								
					value={creditCardChangeForm.get(name)}
					onChange={this.handleChange}
					onBlur={this.handleBlur}
					disabled={processing.get()}
				>
					{optionsRender}
				</select>
				<ErrorMessage text={creditCardChangeFormErrors.get(name)} />		
			</span>
		);
	}	

	render() {				
		const { creditCardChangeForm } = membershipStore;			
		const processing = membershipStore.processing.get();		
		return (
			<span>	
				<div className="row">
					<div className="col-lg-8">
						{membershipStore.alerts.map(alert =>
							<Alert key={alert.message} alert={alert} />
						)}
					</div>
				</div>		
				{!processing &&										
				<form className="needs-validation" noValidate onSubmit={this.handleSubmit}>					
					<div className="row">							
						<div className="col-lg-5 form-group pb-lg-0 mb-lg-0">
							{this.renderInput('cc_number', true)}
						</div>	
						<div className="col-lg-3 form-group pb-lg-0 mb-lg-0">
							{this.renderInput('cc_holder_name', true)}
						</div>	
					</div>
					<div className="row">												
						<div className="col-lg-12 form-group">												
							<CardTypeLogos method={creditCardChangeForm.get('payment_method')} />
						</div>	
					</div>
					<div className="row">																												
						<div className="col-lg-3 form-group">
							{this.renderSelect('cc_expiration_month')}
						</div>	
						<div className="col-lg-3 form-group">	
							{this.renderSelect('cc_expiration_year')}
						</div>							
					</div>																					
					<div className="row">					
						<div className="col-lg-4">																
							<button 
								type="submit" 
								className="tkc-btn btn-block tkc-btn-red font-weight-bold rounded-0" 	
								disabled={processing}																					
							>
								{T('Add Card')}
							</button>	  							
						</div> 														
					</div>	
				</form>
				}
				<div className="row mt-2">					
					<div className="col-lg-8 text-center">
						{processing ? 
							<span>
								<p>
									<Loader width='50px' />																
								</p>									
								<p>
									{T('Processing your credit card change. This may take a while. Please avoid refreshing your browser or navigating away from this page.')}
								</p>									
							</span>
							:
							<span><br /><br /></span>
						}																					
					</div> 														
				</div>	
				<hr className="mb-4 mt-3" />									
				<div className="row">
					<div className="col-lg-8 form-group small text-muted">										 															
						<p>
							Kabbalah Centre International, Inc.<br />
							1062 S. Robertson Blvd., Los Angeles, CA 90035, USA
						</p>																								
						<p>Merchant Outlet is USA.</p>
					</div>						
				</div>															
			</span>
		);
	}

}

export default observer(CreditCardChangeForm);



// WEBPACK FOOTER //
// ./src/components/billing-form/CreditCardChangeForm.js